import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './FloatingCTA.css';

export default function FloatingCTA({ onClick }) {
  const [visible, setVisible] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (user) {
      // Already logged in — take them straight to mentors or dashboard
      if (user.role === 'mentor') navigate('/dashboard/mentor');
      else navigate('/mentors');
    } else {
      onClick(); // open auth modal
    }
  };

  // Hide for logged-in mentors (they don't need "find mentor" CTA)
  if (user?.role === 'mentor') return null;

  const label = user
    ? '🔍 Browse Mentors'
    : '🚀 Join Free — Book a Mentor';

  return (
    <button className={`float-cta ${visible ? 'show' : ''}`} onClick={handleClick}>
      {label}
    </button>
  );
}
